import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationsFinanceProductivity(companyId, regulationId) {
	return dataTransferWrap(
		ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY,dtConfig[ModulesMap.REGULATIONS_FINANCE_PRODUCTIVITY].getRegulationsFinanceProductivity,
		{
			urlParams: {
				companyId,
				regulationId,
			},
		},
	)
}
export default {
	getRegulationsFinanceProductivity,
}